/** @format */
import {HotspotStatusList} from './types';

export const BLOCK_HEIGHT = '154px';

export const BLOCK_HEIGHT_COMPACT = '73px';

export const ALERT_MEDIAPLAN_KEY = 'hs-alert-mediaplan';

export const ALERT_SENSORS_KEY = 'hs-alert-sensors';

export const STATUS_LIST_DEFAULT: HotspotStatusList = {
  mediaplan: {
    isDisplay: true,
    isReady: true,
  },
  funnel: {
    isDisplay: true,
    isReady: true,
  },
  feeds: {
    isDisplay: true,
    isReady: true,
  },
  sensors: {
    isDisplay: true,
    isReady: true,
  },
};

export const HOTSPOT_ALERT_DELAY = 2000;
